import type { Product as ProductType } from '@/features/navigation/types/product';
import { range } from '@/utils/range';
import { Product } from './product';

interface Props {
  products: ProductType[];
  isLoading?: boolean;
}

export const ProductsList = ({ products, isLoading }: Props) => {
  if (isLoading) {
    return range(5).map((num) => <Product.Skeleton key={num} />);
  }

  return products.map((product) => (
    <Product {...product} key={product.id} prefetch={false} />
  ));
};
